import React, { useState, useEffect, useReducer, useContext } from "react";
import openSocket from "../../services/socket-io";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";
import moment from 'moment';

import { makeStyles, withStyles } from "@material-ui/core/styles";


import {
  Chip,
  Avatar,
  Button,
  IconButton,
  InputAdornment,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableFooter,
  TablePagination,
  TextField,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,

} from "@material-ui/core";

import {
  AddCircleOutline,
  DeleteForever,
  DeleteOutline,
  ImportContacts,
  Archive,
  Edit,
  Search,
  WhatsApp,
  Unarchive
} from "@material-ui/icons";

import api from "../../services/api";
import { i18n } from "../../translate/i18n";

import TableRowSkeleton from "../../components/TableRowSkeleton";
import ContactModal from "../../components/ContactModal";
import ContactImportModal from "../../components/ContactImportModal";
import ConfirmationModal from "../../components/ConfirmationModal/";
import MainHeader from "../../components/MainHeader";
import Title from "../../components/Title";
import MainHeaderButtonsWrapper from "../../components/MainHeaderButtonsWrapper";
import NewTicketModalPageContact from "../../components/NewTicketModalPageContact";
import MainContainer from "../../components/MainContainer";
import { Can } from "../../components/Can";
import HexToRgb from "../../components/HexToRgb";
import CustomToolTip from "../../components/ToolTips";

import toastError from "../../errors/toastError";
import { AuthContext } from "../../context/Auth/AuthContext";
import { SettingsContext } from "../../context/Settings/SettingsContext";

const reducer = (state, action) => {
  if (action.type === "LOAD_CONTACTS") {
    return action.payload;
  }

  if (action.type === "UPDATE_CONTACTS") {
    const contact = action.payload;
    const contactIndex = state.findIndex((c) => c.id === contact.id);

    if (contactIndex !== -1) {
      state[contactIndex] = contact;
      return [...state];
    } else {
      return state;
    }
  }

  if (action.type === "DELETE_CONTACT") {
    const contactId = action.payload;

    const contactIndex = state.findIndex((c) => c.id === contactId);
    if (contactIndex !== -1) {
      state.splice(contactIndex, 1);
    }
    return [...state];
  }

  if (action.type === "RESET") {
    return [];
  }
};

const useStyles = makeStyles((theme) => ({
  mainPaper: {
    flex: 1,
    padding: theme.spacing(2),
    margin: theme.spacing(1),
    overflowY: "scroll",
    ...theme.scrollbarStyles,
  },
  csvbtn: {
    textDecoration: 'none'
  },
  avatar: {
    width: "42px",
    height: "42px",
    borderRadius: "25%"
  },
  Width: "165px",
  chips: {
    display: "flex",
    flexWrap: "wrap",
  },
  chip: {
    margin: 2,
  },
  IconButton: {
    marginRight: 5,
  },
}));

const StyledMenu = withStyles({
  paper: {
    border: '1px solid #d3d4d5',
  },
})((props) => (
  <Menu
    elevation={0}
    getContentAnchorEl={null}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'center',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'center',
    }}
    {...props}
  />
));

const StyledMenuItem = withStyles((theme) => ({
  root: {
    '&:focus': {
      backgroundColor: theme.palette.primary.main,
      '& .MuiListItemIcon-root, & .MuiListItemText-primary': {
        color: theme.palette.common.white,
      },
    },
  },
}))(MenuItem);

const Contacts = () => {
  const classes = useStyles();
  const history = useHistory();

  const { user } = useContext(AuthContext);

  const [loading, setLoading] = useState(false);
  const [searchParam, setSearchParam] = useState("");
  const { settings } = useContext(SettingsContext);

  const [contacts, dispatch] = useReducer(reducer, []);
  const [selectedContactId, setSelectedContactId] = useState(null);
  const [contactModalOpen, setContactModalOpen] = useState(false);
  const [deletingContact, setDeletingContact] = useState(null);
  const [deletingAllContact, setDeletingAllContact] = useState(null);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [totalContacts, setTotalContacts] = useState(0);
  const [tagIds, setTagIds] = useState([]);
  const [selectedTagIds, setSelectedTagIds] = useState([]);
  const [newTicketModalOpen, setNewTicketModalOpen] = useState(false);
  const [contactTicket, setContactTicket] = useState({});
  const [modulesOnlyCampaigns, setModulesOnlyCampaigns] = useState();

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [contactImportModalOpen, setContactImportModalOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [exportingContacts, setExportingContacts] = useState(false);
  const [exportProgress, setExportProgress] = useState(0);

  useEffect(() => {
    const loadsettings = async () => {

      const modulesOnlyCampaigns = await settings.find(t => t.key === "modulesOnlyCampaigns");
      setModulesOnlyCampaigns(modulesOnlyCampaigns?.value);

    }
    loadsettings();
  }, [settings]);

  useEffect(() => {
    setPage(0);
  }, [searchParam, rowsPerPage]);


  const handleChangePage = (event, newPage) => setPage(newPage);

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };


  useEffect(() => {
    dispatch({ type: "RESET" });
  }, [searchParam]);

  useEffect(() => {
    setLoading(true);
    const delayDebounceFn = setTimeout(() => {
      const fetchContacts = async () => {
        try {

          const { data } = await api.get("/contacts/", {
            params: {
              searchParam,
              pageNumber: page + 1,
              pageSize: rowsPerPage
            },
          });
          dispatch({ type: "LOAD_CONTACTS", payload: data.contacts });
          setTotalContacts(data.count);
          setLoading(false);

        } catch (err) {
          toastError(err);
          setLoading(false);
        }
      };
      fetchContacts();
    }, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [searchParam, page, rowsPerPage]);

  useEffect(() => {
    const socket = openSocket();

    socket.on("contact", (data) => {
      if (data.action === "update" || data.action === "create") {
        dispatch({ type: "UPDATE_CONTACTS", payload: data.contact });
      }

      if (data.action === "delete") {
        dispatch({ type: "DELETE_CONTACT", payload: +data.contactId });
      }
    });

    return () => {
      socket.disconnect();
    };
  }, []);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/tags");
        setTagIds(data.tags);
      } catch (err) {
        toastError(err);
      }
    })();
  }, []);

  const handleSearch = (event) => {
    setSearchParam(event.target.value.toLowerCase());
  };

  const handleOpenContactModal = () => {
    setSelectedContactId(null);
    setContactModalOpen(true);
  };

  const handleCloseContactModal = () => {
    setSelectedContactId(null);
    setContactModalOpen(false);
  };

  const handleOpenContactImportModal = () => {
    setContactImportModalOpen(true);
    handleCloseMenu();
  };

  const handleCloseContactImportModal = () => {
    setContactImportModalOpen(false);
    setLoading(true);
    const delayDebounceFn = setTimeout(() => {
      const fetchContacts = async () => {
        try {

          const { data } = await api.get("/contacts/", {
            params: {
              searchParam,
              pageNumber: page + 1,
              pageSize: rowsPerPage
            },
          });
          dispatch({ type: "LOAD_CONTACTS", payload: data.contacts });
          setTotalContacts(data.count);
          setLoading(false);

        } catch (err) {
          toastError(err);
          setLoading(false);
        }
      };
      fetchContacts();
      return () => clearTimeout(delayDebounceFn);
    }, 500);

  };

  const handleCloseOrOpenTicket = (ticket) => {
    setNewTicketModalOpen(false);
    if (ticket !== undefined && ticket.id !== undefined) {
      history.push(`/tickets/${ticket.id}`);
    }
    setLoading(false);
  };

  const handleSaveTicket = async (contactId) => {
    if (!contactId) return;
    setLoading(true);
    try {
      const { data: ticket } = await api.post("/tickets", {
        contactId: contactId,
        userId: user?.id,
        status: "open",
      });
      history.push(`/tickets/${ticket.id}`);
    } catch (err) {
      toastError(err);
    }
    setLoading(false);
  };

  const hadleEditContact = (contactId) => {
    setSelectedContactId(contactId);
    setContactModalOpen(true);
  };

  const handleDeleteContact = async (contactId) => {
    try {
      await api.delete(`/contacts/${contactId}`);
      toast.success(i18n.t("contacts.toasts.deleted"));
    } catch (err) {
      toastError(err);
    }
    setDeletingContact(null);
    setSearchParam("");
    setPage(0);
  };

  const handleDeleteAllContact = async () => {
    try {
      await api.delete("/contacts");
      toast.success(i18n.t("contacts.toasts.deletedAll"));
      history.go(0);
    } catch (err) {
      toastError(err);
    }
    setDeletingAllContact(null);
    setSearchParam("");
    setPage(0);
  };

  const handleimportContact = async () => {
    try {
      setLoading(true);
      await api.post("/contacts/import");
      history.go(0);
      setLoading(false);
    } catch (err) {
      toastError(err);
      setLoading(false);
    }
  };

  const handleChange = e => {
    setSelectedTagIds(e.target.value);
  };

  const handleClickMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleExportContacts = async () => {
    if (exportingContacts) return;

    try {
      setExportingContacts(true);
      setExportProgress(0);

      const allContacts = [];
      const exportPageSize = 1000;
      let currentPage = 1;
      let hasMorePages = true;
      let totalPages = 1;

      while (hasMorePages) {
        const { data } = await api.get("/contacts/", {
          params: {
            searchParam,
            pageNumber: currentPage,
            pageSize: exportPageSize,
          },
        });

        if (currentPage === 1) {
          const totalCount = Number(data.count) || 0;
          totalPages = totalCount > 0 ? Math.ceil(totalCount / exportPageSize) : 1;
        }

        allContacts.push(...(data.contacts || []));
        setExportProgress(Math.min(100, Math.round((currentPage / totalPages) * 100)));
        hasMorePages = data.hasMore;
        currentPage += 1;
      }

      const escapeCsvValue = (value) => {
        const rawValue = value ?? "";
        return `"${String(rawValue).replace(/"/g, '""')}"`;
      };

      const csvRows = [
        "name;number;email",
        ...allContacts.map(contact => (
          `${escapeCsvValue(contact.name)};${escapeCsvValue(contact.number)};${escapeCsvValue(contact.email)}`
        ))
      ];

      const csvContent = `\uFEFF${csvRows.join("\n")}`;
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");

      link.href = url;
      link.setAttribute("download", `send4whats-contacts-${moment().format("YYYYMMDD-HHmmss")}.csv`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      toast.success("Contatos exportados com sucesso");
    } catch (err) {
      toastError(err);
    } finally {
      setExportProgress(0);
      setExportingContacts(false);
    }
  };


  return (
    <MainContainer className={classes.mainContainer}>
      <NewTicketModalPageContact
        modalOpen={newTicketModalOpen}
        initialContact={contactTicket}
        onClose={(ticket) => {
          handleCloseOrOpenTicket(ticket);
        }}
      />
      <ContactModal
        open={contactModalOpen}
        onClose={handleCloseContactModal}
        aria-labelledby="form-dialog-title"
        contactId={selectedContactId}
      />
      <ContactImportModal
        open={contactImportModalOpen}
        onClose={handleCloseContactImportModal}
        aria-labelledby="form-dialog-title"
        contactId={selectedContactId}
      />
      <ConfirmationModal
        title={
          deletingContact ? `${i18n.t("contacts.confirmationModal.deleteTitle")} ${deletingContact.name}?`
            : deletingAllContact ? `${i18n.t("contacts.confirmationModal.deleteAllTitle")}`
              : `${i18n.t("contacts.confirmationModal.importTitle")}`
        }
        open={confirmOpen}
        onClose={setConfirmOpen}
        onConfirm={(e) =>
          deletingContact ? handleDeleteContact(deletingContact.id)
            : deletingAllContact ? handleDeleteAllContact(deletingAllContact)
              : handleimportContact()
        }
      >
        {
          deletingContact ? `${i18n.t("contacts.confirmationModal.deleteMessage")}`
            : deletingAllContact ? `${i18n.t("contacts.confirmationModal.deleteAllMessage")}`
              : `${i18n.t("contacts.confirmationModal.importMessage")}`
        }
      </ConfirmationModal>
      <MainHeader>
        <Title>{i18n.t("contacts.title")} ({totalContacts})</Title>
        <MainHeaderButtonsWrapper>
          {/*           
          DESATIVADO TEMPORARIAMENTE
          <InputLabel>{i18n.t("tags.forms.inputLabel")}</InputLabel>

          <Select
            multiple
            labelWidth={60}
            value={selectedTagIds}
            onChange={handleChange}
            MenuProps={{
              anchorOrigin: {
                vertical: "bottom",
                horizontal: "left",
              },
              transformOrigin: {
                vertical: "top",
                horizontal: "left",
              },
              getContentAnchorEl: null,
            }}
            renderValue={selected => (
              <div className={classes.chips}>
                {selected?.length > 0 &&
                  selected.map(id => {
                    const tag = tagIds.find(q => q.id === id);
                    return tag ? (
                      <Chip
                        key={id}
                        style={{ backgroundColor: tag.color }}
                        variant="outlined"
                        label={tag.name}
                        size="small"
                        className={classes.chip}
                      />
                    ) : null;
                  })
                }
              </div>
            )}
          >

            {tagIds.map(tags => (
              <MenuItem key={tags.id} value={tags.id}>
                {tags.name}
              </MenuItem>
            ))}
          </Select>
          */}
          <TextField
            placeholder={i18n.t("contacts.searchPlaceholder")}
            type="search"
            value={searchParam}
            onChange={handleSearch}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Search color="primary" />
                </InputAdornment>
              ),
            }}
          />
          {/* <Can
            role={user.profile}
            perform="drawer-admin-items:view"
            yes={() => (
              <>
                <CustomToolTip title={i18n.t("contacts.buttons.import")}>
                  <Button
                    size="small"
                    variant="contained"
                    color="primary"
                    onClick={(e) => setConfirmOpen(true)}
                  >
                    <ImportContacts fontSize="small" className={classes.IconButton} />
                  </Button>
                </CustomToolTip>
              </>
            )}
          /> */}

          <CustomToolTip title={i18n.t("contacts.buttons.add")}>
            <Button
              size="small"
              variant="contained"
              color="primary"
              onClick={handleOpenContactModal}
            >
              <AddCircleOutline fontSize="small" className={classes.IconButton} /> NOVO
            </Button>
          </CustomToolTip>

          <Button
            aria-controls="customized-menu"
            aria-haspopup="true"
            variant="contained"
            color="primary"
            size="small"
            onClick={handleClickMenu}
          >
            <ImportContacts fontSize="small" className={classes.IconButton} /> IMPORTAR CONTATOS
          </Button>

          <StyledMenu
            anchorEl={anchorEl}
            keepMounted
            open={Boolean(anchorEl)}
            onClose={handleCloseMenu}
          >
            <StyledMenuItem style={{ backgroundColor: "#ffffff" }}>
              <span >Escolha uma opção</span>
            </StyledMenuItem>
            <StyledMenuItem onClick={(e) => { setConfirmOpen(true); handleCloseMenu(); }} id="IMPORTAR DOS CONTATOS">
              <ListItemIcon>
                <ImportContacts />
              </ListItemIcon>
              <ListItemText primary="IMPORTAR DOS CONTATOS" secondary={i18n.t("contacts.buttons.ImportFromContacts")} />
            </StyledMenuItem>
            <StyledMenuItem onClick={handleOpenContactImportModal} id="list">
              <ListItemIcon>
                <Unarchive />
              </ListItemIcon>
              <ListItemText primary="IMPORTAR DE UM ARQUIVO" secondary={i18n.t("contacts.buttons.ImportFromFile")} />
            </StyledMenuItem>
          </StyledMenu>

          <CustomToolTip title={i18n.t("contacts.buttons.export")}>
            <Button
              size="small"
              variant="contained"
              color="primary"
              disabled={exportingContacts}
              onClick={handleExportContacts}
            >
              <Archive fontSize="small" className={classes.IconButton} />
              {exportingContacts ? `EXPORTANDO ${exportProgress}%` : "EXPORTAR"}
            </Button>

          </CustomToolTip>


          <Can
            role={user.profile}
            perform="drawer-admin-items:view"
            yes={() => (
              <>
                <CustomToolTip title={i18n.t("contacts.buttons.delete")}>
                  <Button
                    size="small"
                    variant="contained"
                    color="primary"
                    onClick={(e) => {
                      setConfirmOpen(true);
                      setDeletingAllContact(contacts);
                    }}
                  >
                    <DeleteForever fontSize="small" />
                  </Button>
                </CustomToolTip>
              </>
            )}
          />
        </MainHeaderButtonsWrapper>
      </MainHeader>
      <Paper
        className={classes.mainPaper}
        variant="outlined"
      >
        <Table size="small" >
          <TableHead>
            <TableRow>
              <TableCell padding="checkbox" />
              <TableCell>
                {i18n.t("contacts.table.name")}
              </TableCell>
              <TableCell align="center">
                {i18n.t("contacts.table.whatsapp")}
              </TableCell>
              <TableCell align="center">
                {i18n.t("contacts.table.email")}
              </TableCell>
              <TableCell align="center">
                {i18n.t("global.birthday")}
              </TableCell>
              <TableCell align="center">
                {i18n.t("global.cod")}
              </TableCell>

              <TableCell align="center">
                {i18n.t("tags.forms.inputLabel")}
              </TableCell>

              <TableCell align="center">
                {i18n.t("contacts.table.actions")}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <>
              {contacts
                .map((contact) => (
                  <TableRow key={contact.id}>
                    <TableCell style={{ paddingRight: 0 }}>
                      {<Avatar src={contact.profilePicUrl} className={classes.avatar} fontSize="small" size="small" />}
                    </TableCell>
                    <TableCell>{contact?.name}</TableCell>
                    <TableCell align="center">{contact?.number}</TableCell>
                    <TableCell align="center">{contact?.email}</TableCell>
                    <TableCell align="center">{contact?.birthday ? moment(contact?.birthday).format('DD/MM/YYYY') : ""}</TableCell>
                    <TableCell align="center">{contact?.cod}</TableCell>
                    <TableCell align="center">
                      {contact.tags &&
                        contact.tags.map(tag => {
                          return tag ? (
                            <Chip
                              key={tag.id}
                              style={{ backgroundColor: tag.color, color: HexToRgb(tag.color) }}
                              variant="outlined"
                              label={tag.name}
                              size="small"
                              className={classes.chip}
                            />
                          ) : null;
                        })
                      }

                    </TableCell>
                    <TableCell align="center">
                      {modulesOnlyCampaigns !== "enabled" &&
                        <IconButton
                          size="small"
                          onClick={() => {
                            setContactTicket(contact);
                            setNewTicketModalOpen(true);
                          }}
                        >
                          <WhatsApp color="secondary" />
                        </IconButton>
                      }
                      <IconButton
                        size="small"
                        onClick={() => hadleEditContact(contact.id)}
                      >
                        <Edit color="primary" />
                      </IconButton>
                      <Can
                        role={user.profile}
                        perform="contacts-page:deleteContact"
                        yes={() => (
                          <IconButton
                            size="small"
                            onClick={(e) => {
                              setConfirmOpen(true);
                              setDeletingContact(contact);
                            }}
                          >
                            <DeleteOutline color="primary" />
                          </IconButton>
                        )}
                      />
                    </TableCell>

                  </TableRow>
                ))}
              {loading && <TableRowSkeleton avatar columns={4} />}
            </>
          </TableBody>
          <TableFooter>
            <TableRow>
              <TablePagination
                rowsPerPageOptions={[10, 15, 30, 100]}
                colSpan={3}
                count={totalContacts}
                rowsPerPage={rowsPerPage}
                page={page}
                SelectProps={{
                  inputProps: { 'aria-label': 'rows per page' },
                  native: true,
                }}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </TableRow>
          </TableFooter>
        </Table>
      </Paper>
    </MainContainer>
  );
};

export default Contacts;
